export const waitForElement = (selector: string) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect()
        resolve(document.querySelector(selector))
      }
    })
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}

export function toggleAudio() {
  const current = localStorage.getItem('zoom_audio_enabled') === 'true'
  localStorage.setItem('zoom_audio_enabled', (!current).toString())
}

export function toggleVideo() {
  const current = localStorage.getItem('zoom_video_enabled') === 'true'
  localStorage.setItem('zoom_video_enabled', (!current).toString())
}
